export  const StopType= {
    DROPOFF: 'DROPOFF',
    PICKUP: 'PICKUP'
} 